import { RootState } from "../store";

export const selectDashboardPatients = (state: RootState) =>
  state.dashboard.patients;
export const selectDashboardProviders = (state: RootState) =>
  state.dashboard.providers;
export const selectSelectedProviderIds = (state: RootState) =>
  state.dashboard.selectedProviderIds;
export const selectDashboardLoading = (state: RootState) =>
  state.dashboard.loading;
export const selectDashboardError = (state: RootState) => state.dashboard.error;

// Filter and pagination selectors
export const selectSearchTerm = (state: RootState) =>
  state.dashboard.searchTerm;
export const selectActiveTab = (state: RootState) => state.dashboard.activeTab;
export const selectSortBy = (state: RootState) => state.dashboard.sortBy;
export const selectSortOrder = (state: RootState) => state.dashboard.sortOrder;
export const selectCurrentPage = (state: RootState) =>
  state.dashboard.currentPage;
export const selectPageSize = (state: RootState) => state.dashboard.pageSize;
export const selectTotalCount = (state: RootState) =>
  state.dashboard.totalCount;
